<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Product management</h1>
    <productListTable />
  </v-card>
</template>

<script>
import productListTable from "@/components/back-office/Merchant/ProductApprove/ProductList/ProductListTable.vue";

export default {
  components: {
    productListTable,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Product Management",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/productmanage",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style>
</style>
